export const getDateHandler = (date, time) => {
  const day = date ? new Date(date) : new Date();
  return `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
};
